<template>
	<v-card
		ref="property-card"
		class="property-card"
		elevation="10"
	>
		<v-row no-gutters>
			<v-col
				v-resize="onResize"
				cols="12"
			>
				<div
					class="property-img"
				>
					<v-skeleton-loader
						tile
						type="image"
						max-width="100%"
						:height="maxHeight"
						:style="`${calculated ? '' : 'padding-top: 78%;'}`"
					/>
				</div>
			</v-col>
			<v-col
				cols="12"
				class="property-info pa-3 pb-4"
			>
				<div class="property-title pt-2">
					<v-skeleton-loader type="paragraph" />
				</div>
				<v-row class="property-spec grey--text mt-7 px-3">
					<v-col cols="6">
						<img src="/images/2.0/icon/property-card/ic_area_bk.png">
						<v-skeleton-loader
							type="text"
							width="60%"
						/>
					</v-col>
					<v-col cols="6">
						<img src="/images/2.0/icon/property-card/ic_area-use_bk.png">
						<v-skeleton-loader
							type="text"
							width="60%"
						/>
					</v-col>
				</v-row>
				<v-row class="property-spec grey--text mt-3 px-3">
					<v-col cols="3">
						<img src="/images/2.0/icon/property-card/ic_layers_bk.png">
						<v-skeleton-loader
							type="text"
							width="40%"
						/>
					</v-col>
					<v-col cols="3">
						<img src="/images/2.0/icon/property-card/ic_sofa_bk.png">
						<v-skeleton-loader
							type="text"
							width="40%"
						/>
					</v-col>
					<v-col cols="3">
						<img src="/images/2.0/icon/property-card/ic_shower_bk.png">
						<v-skeleton-loader
							type="text"
							width="40%"
						/>
					</v-col>
					<v-col cols="3">
						<img src="/images/2.0/icon/property-card/ic_car_bk.png">
						<v-skeleton-loader
							type="text"
							width="40%"
						/>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<div class="bgGrey d-flex align-end px-3 pt-3 pb-2">
			<v-skeleton-loader
				type="text"
				width="100%"
			/>
		</div>
	</v-card>
</template>

<script>

export default {
	data:() => ({
		maxHeight: '100%',
		calculated: false
	}),

	methods: {
		onResize () {
			if (process.client) {
				this.$nextTick(() => {
					// this.maxHeight = window.innerWidth > 959 ? '225' : (window.innerWidth > 599 ? '244' : '84vw')
					// this.maxHeight = this.$refs['property-card'].$el.clientWidth * 0.78
					// this.calculated = true;
				})
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.property-card {
	cursor: pointer;
	font-size: 0.9rem;

	.property-info {
		box-sizing: border-box;

		.property-title {
			height: 65px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 3;
			overflow: hidden;

			a {
				text-decoration: none;
				font-weight: bold;
				color: #000;
			}
		}
		.property-spec {
			& > .col {
				padding: 0;
				display: flex;
				align-items: center;
			}

			img {
				width: 1rem;
				margin-right: 5px;
			}
		}
	}

	.v-icon {
		font-size: 1.1rem;
	}
}

.bgGrey {
	background-color: #e9e9e9;
}
</style>
